// 根据Type区分当前上报的page
import { reportSaleUserBehaviorCgi, reportSeasUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import _ from 'lodash';
import EventBus from 'eventing-bus';
import {
  LOAD_LEAD_SIGN_STATISTIC_DETAIL,
  LOAD_LEAD_SIGN_STATISTIC_LIST,
  LOAD_LEAD_SIGN_STATISTIC_REPORT,
} from './interface';

export const getCurrentReportPage = (type, isDetail) => {
  const page1 = '销售';
  switch (type) {
    case 'lead': // 线索界面
      return {
        page1,
        page2: '线索管理',
        page3: isDetail ? '线索详情页' : '',
      };
    case 'potential': // 商机界面
      return {
        page1,
        page2: '商机管理',
        page3: isDetail ? '商机详情页' : '',
      };
    case 'leadHighSeas': // 线索公海池
      return {
        page1,
        page2: '公海池',
        page3: `线索公海${isDetail ? '详情页' : ''}`,
      };
    case 'potentialHighSeas': // 商机公海池
      return {
        page1,
        page2: '公海池',
        page3: `商机公海${isDetail ? '详情页' : ''}`,
      };
    case 'potentialHighSeas-active': // 活跃商机公海池
      return {
        page1,
        page2: '公海池',
        page3: `活跃商机公海${isDetail ? '详情页' : ''}`,
      };
    case 'potentialHighSeas-silence': // 沉默商机公海池'
      return {
        page1,
        page2: '公海池',
        page3: `沉默商机公海${isDetail ? '详情页' : ''}`,
      };
    default:
      return { page1 };
  }
};

// 根据操作类型组装behavior
export const getBehavior = (pageType, isOperate) => {
  switch (pageType) {
    case 'lead': // 线索界面
    case 'leadHighSeas': // 线索公海池
      return isOperate ? '操作线索' : '看到标记线索';
    case 'potential': // 商机界面
    case 'potentialHighSeas': // 商机公海池
      return isOperate ? '操作商机' : '看到标记商机';
    case 'potentialHighSeas-active': // 活跃商机公海池
      return isOperate ? '操作活跃商机' : '看到标记活跃商机';
    case 'potentialHighSeas-silence': // 沉默商机公海池
      return isOperate ? '操作沉默商机' : '看到标记沉默商机';
    default:
      return;
  }
};
// 带标记的notice上报
export const reportNotice = (pageType, signType, leadId, value, isOperate, isDetail) => {
  const page4 = signType;
  const dataBehavior = {
    ...getCurrentReportPage(pageType, isDetail),
    page4,
    behavior: getBehavior(pageType, isOperate),
    leadId,
    value,
  };
  if(value === '打开页面' && isDetail) {
    dataBehavior.behavior = '打开页面';
    dataBehavior.value = '';
  }
  reportSaleUserBehaviorCgi({ data: dataBehavior });
};


// 策略二期公海池埋点
export const reportNoticeSeas = (pageType, query, leadId, value, isOperate, isDetail, otherParams = {}) => {
  const isSplit = _.includes(value, '-');
  const arr =  value.split('-');
  const page4 = isSplit ? _.head(arr) : '';
  const dataBehavior = {
    ...getCurrentReportPage(pageType, isDetail),
    page4,
    behavior: _.last(arr),
    query,
    leadId,
    eventName: '策略二期',
    ...otherParams,
  };
  if(value === '打开页面' && isDetail) {
    dataBehavior.behavior = '打开页面';
    dataBehavior.value = '';
  }
  reportSeasUserBehaviorCgi({ data: dataBehavior });
};

// 批量上报带标记的notice上报
export const reportNoticeBatch = (pageType, list, value, isOperate) => {
  if (_.isEmpty(list)) return;
  const filterList = _.filter(list, ({ leadSigns = [] }) => !_.isEmpty(leadSigns));
  if (_.isEmpty(filterList)) return;
  _.map(filterList, ({ leadId = '', leadSigns = [] }) => {
    const { name = '' } = _.head(leadSigns);
    const dataBehavior = {
      ...getCurrentReportPage(pageType),
      page4: name ? `${name}` : '',
      behavior: getBehavior(pageType, isOperate),
      leadId,
      value,
    };
    reportSaleUserBehaviorCgi({ data: dataBehavior });
  });
};

// 列表页操作按钮刷新
export const refreshStatistic = () => {
  EventBus.publish(LOAD_LEAD_SIGN_STATISTIC_LIST);
};

// 详情页跟进记录上报
export const refreshStatisticOnReport = (pageInfo) => {
  EventBus.publish(LOAD_LEAD_SIGN_STATISTIC_REPORT, pageInfo);
};

// 详情页跟进记录操作刷新
export const refreshStatisticOnDetail = (pageInfo) => {
  EventBus.publish(LOAD_LEAD_SIGN_STATISTIC_DETAIL, pageInfo);
  refreshStatisticOnReport(pageInfo);
};
